module.exports = __webpack_public_path__ + "img/welcome_6.bf86d957.jpg";